//@ts-nocheck
//@ts-ignore
import { useEffect, useState } from 'react';
import { images } from '../constants/images';

export const useProgressiveImageLoad = (currentPage, userFlow) => {
  const [loadedImages, setLoadedImages] = useState(new Set());

  useEffect(() => {
    const getImagesForPage = (page) => {
      const pageImages = {
        'personal-plan-2': Object.values(images),
        'calorie-free': [images.calorieFree],
        'metabolism-type': [
          images.metabolismType,
          images.self,
          images.bodySpeaks,
          images.motivHeart,
        ],
        'metabolism-type-2': [images.metabolismType2],
        'personal-plan-dynamic': [
          images.dnaReviewDaniel,
          images.dnaReviewMaria,
          images.dnaReviewSophie,
          images.metabolism,
          images.dna,
          images.yogurt, images.pizza, images.toast, images.tortilla,
          images.dietImg, images.vineImg
        ],
        'metabolism-impact': [images.metabolismImpact],
        'progress-unlocked': [images.progressUnlocked],
        'elite-insight-access': [images.elite],
        'upsale-nutrition-bundle': [images.upsaleBundle],
        'upsale-dynamic': [images.upsaleBundle, images.upsaleEthnicity, images.upsaleDna],
        'ethnicity-nutrition-promise': [images.ethnicityNutrition],
        'face-scan-animation': [images.faceScanAnimationPoster],
        'dna-map': [images.dnaMap],
        'dna-face': [images.dnaFace],
        // 'self-awareness-start': [images.self],
        // 'body-speaks': [images.bodySpeaks],
        // 'motivation-heart': [images.motivHeart]
      };
      return pageImages[page] || [];
    };

    const currentPageImages = getImagesForPage(currentPage);
    currentPageImages.forEach((src) => {
      if (!loadedImages.has(src)) {
        const img = new Image();
        img.src = src;
        img.onload = () => setLoadedImages((prev) => new Set([...prev, src]));
      }
    });

    const currentIndex = userFlow.indexOf(currentPage);
    const nextPages = userFlow.slice(currentIndex + 1, currentIndex + 3);

    nextPages.forEach((page) => {
      const nextPageImages = getImagesForPage(page);
      setTimeout(() => {
        nextPageImages.forEach((src) => {
          if (!loadedImages.has(src)) {
            const img = new Image();
            img.src = src;
          }
        });
      }, 1000);
    });
  }, [currentPage, userFlow, loadedImages]);

  return loadedImages;
};
